import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { Building, Mail, Phone, FileText } from 'lucide-react';

export const Impressum = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="pt-32 pb-20">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="mb-12">
            <span className="inline-block px-4 py-2 rounded-full bg-[#8B1538]/10 text-[#8B1538] text-sm font-semibold mb-4">
              Rechtliches
            </span>
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Impressum
            </h1>
            <p className="text-lg text-gray-600">
              Angaben gemäß § 5 TMG
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-8 lg:p-12 space-y-8">
            {/* Unternehmensdaten */}
            <div>
              <div className="flex items-center mb-4">
                <Building className="w-6 h-6 text-[#8B1538] mr-3" />
                <h2 className="text-2xl font-bold text-gray-900">Unternehmensangaben</h2>
              </div>
              <div className="ml-9 space-y-2 text-gray-700">
                <p className="font-semibold text-lg">Kalem Baustoffhandel</p>
                <p>Waldseestr. 46</p>
                <p>63486 Bruchköbel</p>
                <p className="mt-4"><span className="font-semibold">Inhaber:</span> Enes Cuhadar</p>
                <p><span className="font-semibold">Rechtsform:</span> Einzelunternehmer</p>
              </div>
            </div>

            {/* Kontakt */}
            <div className="border-t border-gray-200 pt-8">
              <div className="flex items-center mb-4">
                <Phone className="w-6 h-6 text-[#8B1538] mr-3" />
                <h2 className="text-2xl font-bold text-gray-900">Kontakt</h2>
              </div>
              <div className="ml-9 space-y-3 text-gray-700">
                <p>
                  <span className="font-semibold">Telefon:</span>{' '}
                  <a href="tel:+4917912953010" className="text-[#8B1538] hover:underline">
                    0179 / 12 95 310
                  </a>
                </p>
                <p>
                  <span className="font-semibold">E-Mail:</span>{' '}
                  <a href="mailto:info@kalembaustoffe.de" className="text-[#8B1538] hover:underline">
                    info@kalembaustoffe.de
                  </a>
                </p>
              </div>
            </div>

            {/* Umsatzsteuer-ID */}
            <div className="border-t border-gray-200 pt-8">
              <div className="flex items-center mb-4">
                <FileText className="w-6 h-6 text-[#8B1538] mr-3" />
                <h2 className="text-2xl font-bold text-gray-900">Umsatzsteuer-ID</h2>
              </div>
              <div className="ml-9 text-gray-700">
                <p>
                  <span className="font-semibold">Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG:</span>
                </p>
                <p className="text-lg font-mono mt-2">DE358964082</p>
              </div>
            </div>

            {/* Verantwortlich für den Inhalt */}
            <div className="border-t border-gray-200 pt-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
              </h2>
              <div className="text-gray-700">
                <p className="font-semibold">Enes Cuhadar</p>
                <p>Waldseestr. 46</p>
                <p>63486 Bruchköbel</p>
              </div>
            </div>

            {/* EU-Streitschlichtung */}
            <div className="border-t border-gray-200 pt-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                EU-Streitschlichtung
              </h2>
              <div className="text-gray-700 leading-relaxed">
                <p>
                  Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
                </p>
                <p className="mt-2">
                  <a 
                    href="https://ec.europa.eu/consumers/odr" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-[#8B1538] hover:underline"
                  >
                    https://ec.europa.eu/consumers/odr
                  </a>
                </p>
                <p className="mt-4">
                  Unsere E-Mail-Adresse finden Sie oben im Impressum.
                </p>
              </div>
            </div>

            {/* Verbraucherstreitbeilegung */}
            <div className="border-t border-gray-200 pt-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                Verbraucherstreitbeilegung / Universalschlichtungsstelle
              </h2>
              <div className="text-gray-700 leading-relaxed">
                <p>
                  Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
                </p>
              </div>
            </div>

            {/* Haftungsausschluss */}
            <div className="border-t border-gray-200 pt-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                Haftung für Inhalte
              </h2>
              <div className="text-gray-700 leading-relaxed space-y-4">
                <p>
                  Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                </p>
                <p>
                  Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                </p>
              </div>
            </div>

            {/* Haftung für Links */}
            <div className="border-t border-gray-200 pt-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                Haftung für Links
              </h2>
              <div className="text-gray-700 leading-relaxed space-y-4">
                <p>
                  Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
                </p>
                <p>
                  Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                </p>
              </div>
            </div>

            {/* Urheberrecht */}
            <div className="border-t border-gray-200 pt-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                Urheberrecht
              </h2>
              <div className="text-gray-700 leading-relaxed space-y-4">
                <p>
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                </p>
                <p>
                  Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};